import { render, staticRenderFns } from "./CommonTable.vue?vue&type=template&id=18484b45&scoped=true&"
import script from "./CommonTable.vue?vue&type=script&lang=ts&"
export * from "./CommonTable.vue?vue&type=script&lang=ts&"
import style0 from "./CommonTable.vue?vue&type=style&index=0&id=18484b45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18484b45",
  null
  
)

export default component.exports